import { combineReducers } from 'redux';
import CustomizerReducer from './customizer/CustomizerReducer';
import notesReducer from './notes/NotesReducer';
import emailReducer from './email/EmailReducer';

const RootReducers = combineReducers({
  CustomizerReducer,
  notesReducer,
  emailReducer,
});

export default RootReducers;
